module.exports = __webpack_public_path__ + "548f863114f0219c7f39dd5dffb605a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/sources/playIcon.png
// module id = V6n1
// module chunks = 0